import { render } from "./cbj.vue?vue&type=template&id=4db0639d&scoped=true"
import script from "./cbj.vue?vue&type=script&lang=js"
export * from "./cbj.vue?vue&type=script&lang=js"

import "./cbj.vue?vue&type=style&index=0&id=4db0639d&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4db0639d"]])

export default __exports__